<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">{{ title }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <upgrade-overlay :title="year + ' Profit & Loss'" :upgradeImg="'dashboard.png'" :placeholderImg="'placeholders/profit-loss.png'" v-if="!subscribed"></upgrade-overlay>
      <div v-else>
        <b-card no-body>
          <b-card-header>
            <b-row>
              <b-col md="6">
                <h3 class="title">Profit & Loss</h3>
              </b-col>
              <b-col md="6" class="text-right">
                <b-button-group v-if="reportType == 'overview'">
                  <b-button :variant="type == 'amount' ? 'primary' : 'outline-primary'" @click="type = 'amount'">$</b-button>
                  <b-button :variant="type == 'percent' ? 'primary' : 'outline-primary'" @click="type = 'percent'">%</b-button>
                </b-button-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <base-input label="Report Type" label-for="reportType">
                  <el-select v-model="reportType">
                    <el-option v-for="type in reportTypes"
                               :key="type.label"
                               :label="type.label"
                               :value="type.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="3">
                <base-input label="Year" label-for="yearInput">
                  <el-select v-model="year">
                    <el-option v-for="year in years"
                               :key="year.label"
                               :label="year.label"
                               :value="year.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="6" v-if="reportType == 'charts'">
                <b-form-group :label="chartType == 'monthly' ? 'Month' : 'Quarter'" label-class="form-control-label">
                  <b-input-group>
                    <template #prepend>
                      <b-button :variant="chartType == 'monthly' ? 'clarity' : 'outline-clarity'" @click="chartType = 'monthly'">Monthly</b-button>
                      <b-button :variant="chartType == 'quarterly' ? 'clarity' : 'outline-clarity'" @click="chartType = 'quarterly'">Quarterly</b-button>
                    </template>
                    <b-form-select v-model="month" :options="months" v-if="chartType == 'monthly'"></b-form-select>
                    <b-form-select v-model="quarter" v-if="chartType == 'quarterly'">
                      <b-form-select-option v-for="quarter in quarters" :key="quarter.value" :value="quarter.value">{{ quarter.label }}</b-form-select-option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-header>
          <div  v-if="loading">
            <h3 class="text-center mt-4 text-danger">Loading may take up to 60 seconds.</h3>
            <loading-panel></loading-panel>
          </div>
          <div v-else>
            <b-table small responsive :items="profit_loss" :fields="fields" sticky-header="850px" foot-clone v-if="reportType == 'overview'">
              <template #cell(section)="row">
                <div v-if="row.item.section == 'Agents Commission'">
                  <b-button class="toggle-btn ml--2" variant="link" v-b-toggle="['agents', 'agents-commission']" @click="agentsActive = !agentsActive">
                    <span class="icon arrow"></span>
                    {{ row.item.section }}
                  </b-button>
                  <b-collapse visible id="agents">
                    <table class="table borderless">
                      <tr v-for="(agent, key) in row.item.agents" :key="key">
                        <td class="pr-0 pb-0 pl-2">{{ agent }}</td>
                      </tr>
                    </table>
                  </b-collapse>
                </div>
                <div v-else>
                  <div v-if="row.item.items">
                    <b-button class="toggle-btn ml--2" variant="link" v-b-toggle="'row' + row.index">
                      <span class="icon arrow"></span>
                      {{ row.item.section }}
                    </b-button>
                    <b-collapse :id="'row' + row.index">
                      <ul class="mb-1 pl-2">
                        <li v-for="(item, index) in row.item.items" :key="index">{{ item }}</li>
                      </ul>
                    </b-collapse>
                  </div>
                  <span v-else>{{ row.item.section }}</span>
                </div>
              </template>

              <template #cell(total)="row">
                <div v-if="!['Income', 'Cost of Sale', 'Expenses', 'Additional Income'].includes(row.item.section)">
                  <span v-if="type == 'amount'">{{ row.item.total.amount | currency }}</span>
                  <span v-else>{{ row.item.total.percent.toFixed(2) }}%</span>
                </div>
              </template>

              <template #cell()="row">
                <div v-if="['Income', 'Cost of Sale', 'Expenses', 'Additional Income'].includes(row.item.section)">
                  {{ row.item.title }}
                </div>
                <div v-else-if="row.item.section == 'Agents Commission'">
                  <span v-if="type == 'amount'">{{ row.item[row.field.key].total | currency }}</span>
                  <span v-else>{{ row.item[row.field.key].percent.toFixed(2) }}%</span>
                  <b-collapse visible id="agents-commission">
                    <table class="table borderless">
                      <tr v-for="(agent, key) in row.item.agents" :key="key">
                        <td class="pl-0 pr-0 pb-0">
                          <span v-if="type == 'amount'">{{ row.item[row.field.key].details[agent] ?  row.item[row.field.key].details[agent].amount : 0 | currency}}</span>
                          <span v-else>{{ row.item[row.field.key].details[agent] ? row.item[row.field.key].details[agent].percent.toFixed(2) : 0 }}%</span>
                        </td>
                      </tr>
                    </table>
                  </b-collapse>
                </div>
                <div v-else>
                  <span v-if="type == 'amount'">{{ row.item[row.field.key].amount | currency }}</span>
                  <span v-else>{{ row.item[row.field.key].percent.toFixed(2) }}%</span>
                </div>
              </template>

              <!-- Footer Net Values -->
              <template #foot(section)="row">
                NET INCOME
              </template>
              <template #foot()="row">
                <span :class="calculateTotal(row.field.key) < 0 ? 'text-danger' : ''">{{ calculateTotal(row.field.key) | currency }}</span>
              </template>
            </b-table>
            <div v-if="reportType == 'financials'">
              <b-table small responsive :items="expense_breakdown" :fields="fields" sticky-header="850px" foot-clone thead-class="hidden_header">
                <template #cell(section)="row">
                  <b-button class="toggle-btn-2 ml--2" variant="link" @click="row.toggleDetails">
                    <i class="fas fa-caret-right"></i>
                    {{ row.item.section }}
                  </b-button>
                </template>
                <template #cell()="row">
                  {{ row.item[row.field.key] | currency }}
                </template>
                <template #row-details="row">
                  <b-table small responsive :items="row.item.details" :fields="fields" sticky-header="850px">
                    <template #cell(section)="row">
                      {{ row.item.section }}
                    </template>
                    <template #cell()="row">
                      {{ row.item[row.field.key] | currency }}
                    </template>
                  </b-table>
                </template>
                <template #foot(section)="row">
                  Totals
                </template>
                <template #foot()="row">
                  <span>{{ calculateExpenseTotals(row.field.key) | currency }}</span>
                </template>
              </b-table>
            </div>
          </div>
        </b-card>
        <b-row v-if="reportType == 'charts'">
          <b-col md="4">
            <expense-percent-chart :userRoute="userRoute" :year="year" :month="month" :quarter="quarter"></expense-percent-chart>
          </b-col>
          <b-col md="4">
            <income-percent-chart :userRoute="userRoute" :year="year" :month="month" :quarter="quarter"></income-percent-chart>
          </b-col>
          <b-col md="4">
            <cos-percent-chart :userRoute="userRoute" :year="year" :month="month" :quarter="quarter"></cos-percent-chart>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {Select, Option} from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import LoadingPanel from '@/components/LoadingPanel';
import UpgradeOverlay from '@/views/Components/Overlays/UpgradeOverlay';
import ExpensePercentChart from '@/views/Components/Charts/ExpensePercentChart';
import IncomePercentChart from '@/views/Components/Charts/IncomePercentChart';
import CosPercentChart from '@/views/Components/Charts/CosPercentChart';


export default {
  mixins: [errorsMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    RouteBreadCrumb,
    LoadingPanel,
    UpgradeOverlay,
    ExpensePercentChart,
    IncomePercentChart,
    CosPercentChart,
  },
  data() {
    return {
      items: null,
      year: new Date().getFullYear(),
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
      month: '',
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      chartType: 'monthly',
      filters: false,
      income: [],
      cos: [],
      financials: [],
      fields: [
        {
          key: 'section',
          label: '',
          tdClass: 'tdClass'
        },
        {
          key: 'January',
          tdClass: 'tdClass'
        },
        {
          key: 'February',
          tdClass: 'tdClass'
        },
        {
          key: 'March',
          tdClass: 'tdClass'
        },
        {
          key: 'April',
          tdClass: 'tdClass'
        },
        {
          key: 'May',
          tdClass: 'tdClass'
        },
        {
          key: 'June',
          tdClass: 'tdClass'
        },
        {
          key: 'July',
          tdClass: 'tdClass'
        },
        {
          key: 'August',
          tdClass: 'tdClass'
        },
        {
          key: 'September',
          tdClass: 'tdClass'
        },
        {
          key: 'October',
          tdClass: 'tdClass'
        },
        {
          key: 'November',
          tdClass: 'tdClass'
        },
        {
          key: 'December',
          tdClass: 'tdClass'
        },
        {
          key: 'total',
          tdClass: 'tdClass'
        }
      ],
      type: 'amount',
      category: {
        category: '',
        items: []
      },
      loading: false,
      reportType: 'overview',
      reportTypes: [
        { value: 'overview', label: 'Overview' },
        { value: 'financials', label: 'Expenses Breakdown' },
        { value: 'charts', label: 'Charts' },
      ],
      expense_breakdown: [],
      quarter: '',
      quarters: [
        { value: '', label: 'Select a Quarter' },
        { value: 1, label: 'Q1' },
        { value: 2, label: 'Q2' },
        { value: 3, label: 'Q3' },
        { value: 4, label: 'Q4' },
      ]
    };
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute',
      subBasic: 'profile/subBasic',
      subStandard: 'profile/subStandard',
      subPremium: 'profile/subPremium'
    }),
    subscribed() {
      return this.subBasic || this.subStandard || this.subPremium;
    },
    title() {
      return 'Profit & Loss';
    },
    owner() {
      const roles = this.$store.getters["roles/roles"];
      return roles[0] == 'owner';
    },
    profit_loss() {
      return [...this.income, ...this.cos, ...this.financials];
    },

  },
  methods: {
    async getProfitLossIncome() {
      this.loading = true;
      await axios.get(this.userRoute + '/reports/profit-loss/income?year=' + this.year)
      .then(response => {
        this.income = response.data;
        this.getProfitLossCos();
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getProfitLossCos() {
      await axios.get(this.userRoute + '/reports/profit-loss/cos?year=' + this.year)
      .then(response => {
        this.cos = response.data;
        this.getProfitLossFinancials();
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getProfitLossFinancials() {
      await axios.get(this.userRoute + '/reports/profit-loss/financials?year=' + this.year)
      .then(response => {
        this.financials = response.data;
        this.loading = false;
      })
      .catch(error => {
        this.error(error);
      });
    },
    async download() {
      await axios.get(this.userRoute + '/expenses/profit-loss/export?year=' + this.year)
      .then(response => {
        swal.fire({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Profit & Loss'
        }).then(result => {
          if(result.isConfirmed) {
            window.open(response.data.link);
          }
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    tdClass(value, key, item) {
      const fields = ['Gross Income', 'Total Expenses', 'Total Additional Income', 'Total Cost of Sale', 'Gross Profit'];

      if (item.type && item.type == 'title') {
        return 'bold-cell text-uppercase bg-danger text-white';
      } else if (item.type && item.type == 'category') {
        return 'bold-cell text-uppercase bg-secondary';
      } else if(fields.includes(item.section)) {
        return 'bold-cell';
      }
    },
    calculateTotal(month) {
      const fields = ['Gross Income', 'Total Expenses', 'Total Additional Income', 'Total Cost of Sale'];
      
      const items = this.profit_loss.filter(item => {
        return fields.includes(item.section);
      });

      if(items.length == 4) {
        return items[0][month].amount - items[1][month].amount - items[2][month].amount + items[3][month].amount;
      } else {
        return items[0][month].amount - items[1][month].amount + items[2][month].amount;
      }
    },
    async getExpensesBreakdown() {
      this.loading = true;
      await axios.get(this.userRoute + '/reports/profit-loss/financials/expenses?year=' + this.year)
      .then(response => {
        this.expense_breakdown = response.data;
        this.loading = false;
      })
      .catch(error => {
        this.error(error);
      });
    },
    calculateExpenseTotals(month) {
      let total = 0;
      this.expense_breakdown.forEach(item => {
        if (Object.keys(item).includes(month)) {
          total = total + item[month];
        }
      });

      return total;
    },
  },
  created() {
    this.getProfitLossIncome();
  },
  mounted() {
    document.title = this.title + " | ClarityNOW";
  },
  watch: {
    year(to, from) {
      if (this.reportType == 'overview') {
        this.getProfitLossIncome();
      }

      if (this.reportType == 'financials') {
        this.getExpensesBreakdown();
      }
    },
    reportType(to, from) {
      if (to == 'overview') {
        this.getProfitLossIncome();
      }

      if (to == 'financials') {
        this.getExpensesBreakdown();
      }
    }
  }
};
</script>
<style lang="scss">
.bold-cell {
  font-weight: 800;
}
.borderless td, .borderless th {
  border: none;
  font-weight: normal;
}
.toggle-btn {
  padding: 0;
  font-weight: 400;

  &:focus {
    box-shadow: none;
  }
}
.toggle-btn-2 {
  padding: 0;
  font-weight: 600;
  color: #525f7f;

  &:focus {
    box-shadow: none;
  }
}
.icon::before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
.toggle-btn .arrow::before {
  font-family: "Font Awesome 6 Free"; font-weight: 900; content: "\f0da";
}
.toggle-btn.not-collapsed .arrow::before {
  font-family: "Font Awesome 6 Free"; font-weight: 900; content: "\f0d7";
}
.b-table-details > td {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.b-table-has-details .toggle-btn-2 .fa-caret-right:before {
  font-family: "Font Awesome 6 Free"; font-weight: 900; content: "\f0d7";
}
.btn-clarity {
  border: none;
  background-color: #D45E5E;
  color: #ffffff;

  &:hover {
    color: #ffffff;
  }

  &:focus {
    box-shadow: none;
  }
}
.btn-outline-clarity {
  border-color: #D45E5E;
  background-color: #ffffff;
  color: #D45E5E;

  &:focus {
    box-shadow: none;
  }
}
</style>